import type { Slug } from '@bridebook/toolbox/src/types';
import { AddedToBookedSuppliersAction } from '@bridebook/web/lib/shortlist/action-types';

export const slugEquals = (slug: Slug) => (action: AddedToBookedSuppliersAction) =>
  action.payload.item.type === slug;
